"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _Button = _interopRequireDefault(require("./Button"));

var _LargeButton = _interopRequireDefault(require("./LargeButton"));

var _Text = require("./Text");

var _theme = _interopRequireDefault(require("./theme"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var Submit = (0, _styledComponents["default"])(_Button["default"].input).attrs({
  type: 'submit'
})([], _Text.caps);
Submit.lg = (0, _styledComponents["default"])(_LargeButton["default"].input).attrs({
  type: 'submit'
})([], _Text.caps);
var attrs = {
  theme: _theme["default"],
  caps: true
};
Submit.defaultProps = attrs;
Submit.lg.defaultProps = attrs;
var _default = Submit;
exports["default"] = _default;